/* @jsx h */
import { defineComponent, h, PropType } from "vue";
import { useWebHaptics } from "web-haptics/vue";

export type HapticButtonProps = {
  onClick?: (e: MouseEvent) => void;
};

export const HapticButton = defineComponent<HapticButtonProps>({
  name: "HapticButton",
  props: ["onClick"],
  setup(props, { slots, attrs }) {
    const { trigger } = useWebHaptics();
    return () => (
      <button
        {...attrs}
        onClick={(e: MouseEvent) => {
          trigger();
          props.onClick?.(e);
        }}
      >
        {slots.default?.()}
      </button>
    );
  },
});
